module.exports = __webpack_public_path__ + "img/mascot@2x.aed3615d.png";